import React from "react";

var LightningIcon = function LightningIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21 9h-6.182L18 2H8L3 13h5.769L6 22z"
  }));
};

LightningIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
LightningIcon.defaultProps.solid = true;
export default LightningIcon;